// @flow
import { ApiBase } from 'api/api'
import {
  makeDeleteRequest,
  makePostRequest,
  makePutRequest,
} from 'api/fetchCalls'
import type {
  CreatedGoogleDriveSetting,
  CreateGoogleDriveSetting,
} from 'types/google_integrations'

export const addGoogleDriveSettings = async (
  data: CreateGoogleDriveSetting
): Promise<CreatedGoogleDriveSetting> => {
  return await makePostRequest(`${ApiBase}/google/drive/settings`, {
    body: JSON.stringify(data),
  })
}

export const updateGoogleDriveSettings = async (
  id: string,
  data: CreateGoogleDriveSetting
): Promise<CreatedGoogleDriveSetting> => {
  return await makePutRequest(`${ApiBase}/google/drive/settings/${id}`, {
    body: JSON.stringify(data),
  })
}

export const deleteGoogleDriveSettings = async (id: string): Promise<void> => {
  return await makeDeleteRequest(`${ApiBase}/google/drive/settings/${id}`)
}
